import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Form, FormControl } from '@angular/forms';

@Component({
  selector: 'rr-ai-control-chat',
  standalone: false,
  templateUrl: './ai-control-chat.component.html',
  styleUrl: './ai-control-chat.component.scss'
})
export class AiControlChatComponent implements OnChanges {
  @Input() interview_partner: any;
  @Input() persona: any;
  @Input() control: FormControl = new FormControl();
  @Input() chat: any;
  @Input() showOptions: boolean = true;

  @Output() suggestionClicked: EventEmitter<any> = new EventEmitter();
  @Output() refresh: EventEmitter<any> = new EventEmitter();
  // @Output() aianswer: EventEmitter<any> = new EventEmitter();

  showResult: boolean = false;
  showSuggestions: boolean = true;
  value: any;
  letters: string[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

  clickSuggestion(text: string, suggestion: any) {
    this.control.setValue(JSON.stringify({ text: text, option: suggestion }));
    this.value = suggestion
    this.suggestionClicked.emit(suggestion);
    this.showSuggestions = false;
    this.showResult = true;
  }

  answerForMe(item: any) {
    // random number between 0 and suggestions.length
    let randomIndex = Math.floor(Math.random() * item.options.length - 1);
    // console.log('SELECT FOR ME => Random index', randomIndex);
    // console.log('SELECT FOR ME => Options.length', item.options.length - 1);
    if (randomIndex < 0) randomIndex = randomIndex * -1;

    this.control.setValue(JSON.stringify({ text: item.text, option: item.options[randomIndex] }));
    this.suggestionClicked.emit(item.options[randomIndex]);
    this.value = item.options[randomIndex]
    this.showSuggestions = false;
    this.showResult = true;
  }
  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes['chat']?.currentValue) {
      let optionsExiste = await changes['chat'].currentValue.find((cp: any) => cp.options || cp.follow_up_question || cp.turn)
      if (!optionsExiste) {
        this.refresh.emit()
        console.log('ERROR', changes['chat'].currentValue);

        return;
      }
      for await (let obj of changes['chat'].currentValue) {
        // console.log(obj);

        if (obj.options && obj.options.length !== 3 && obj.options.length === 12) {
          let final: any[] = [];
          final.push(`${obj.options[1]}${obj.options[2]} ${obj.options[3]}`)
          final.push(`${obj.options[5]}${obj.options[6]} ${obj.options[7]}`)
          final.push(`${obj.options[9]}${obj.options[10]} ${obj.options[11]}`)
          obj.options = final

        }
        if (obj.options && obj.options.length !== 3 && obj.options.length === 9) {
          let final: any[] = [];
          final.push(`${obj.options[0]}${obj.options[1]} ${obj.options[2]}`)
          final.push(`${obj.options[3]}${obj.options[4]} ${obj.options[5]}`)
          final.push(`${obj.options[6]}${obj.options[7]} ${obj.options[8]}`)
          obj.options = final

        }
        if (obj.options && obj.options.length !== 3) {

          obj.options = await obj.options.filter((o: string) => o.length > 4)
        }

      }

      let options = await this.chat.find((c: any) => c.options)

      // console.log('options', options);

    }
    if (changes['control']?.currentValue) {
      // console.log('Control value changed:', changes['control']?.currentValue.value);
      if (changes['control']?.currentValue.value !== '') {
        this.showSuggestions = false;
        this.showResult = true;
        let v = JSON.parse(changes['control']?.currentValue.value);
        this.value = v.option;
      }
    }
  }
}
